import React from 'react';

/* Common */
import PriceFormat from "../../common/PriceFormat";

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFlowPrices({ summary }) {

    return (
        <div className="row gutters-2">
            <hr className="my-2 w-100"></hr>
            {Object.entries(summary?.prices || {}).map(([key, price]) => (
                <div key={key} className="col-12">
                    <div className="row gutters-3 align-items-center">
                        <div className="col text--16">{price?.label}</div>
                        <div className="col-auto text-right">
                            <p className="mb-0 font-weight-bold">
                                {price?.discountPrice && (
                                    <del className="text--sm font-weight-normal text-muted--40 mr-2">
                                        <PriceFormat value={price?.price} />
                                    </del>
                                )}

                                {price?.label === "Private lease" ? (
                                        <p>{price?.price}</p>
                                ) : price?.suffix !== undefined && price?.price === null ? (
                                    // ALMN lease price without an amount (WAAL-1244)
                                    <span className="font-weight-normal">{trans('app.vdp_intro_card.on_request', {}, 'op aanvraag')}</span>
                                ) : price?.suffix ? (
                                    <>
                                        <PriceFormat value={price?.price} />
                                        <span className="font-weight-normal text--14"> {price.suffix}</span>
                                    </>
                                ) : (
                                    <PriceFormat value={price?.discountPrice ? price?.discountPrice : price?.price} />
                                )}
                            </p>
                            {price?.discount && (
                                <p className="text-danger text--14 font-weight-medium line-height-1">
                                    <PriceFormat value={price.discount} /> voordeel
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
